/* UNINSPIRED LP — tee crosssell interactions
   Same shape as the main purchase card: size pills + AJAX ATC → opens the
   parent theme's cart drawer. Falls back to /cart redirect if no drawer. */
(function () {
  var section = document.querySelector('[data-tee-section]');
  if (!section) return;

  var sizes = Array.prototype.slice.call(section.querySelectorAll('[data-lp-size]'));
  var variantInput = section.querySelector('[data-lp-variant-id]');

  sizes.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.classList.contains('is-oos')) return;
      sizes.forEach(function (b) {
        b.classList.remove('is-active');
        b.setAttribute('aria-checked', 'false');
      });
      btn.classList.add('is-active');
      btn.setAttribute('aria-checked', 'true');
      if (variantInput) variantInput.value = btn.dataset.variantId;
    });
  });

  function openCartDrawer(addedItem) {
    document.dispatchEvent(new CustomEvent('cart:added', { detail: addedItem, bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    var drawer = document.querySelector('cart-element#cart-drawer, #cart-drawer');
    if (!drawer) { window.location.href = '/cart'; return; }
    var toggles = Array.prototype.slice.call(document.querySelectorAll('[data-cart-drawer-toggle]'));
    var openToggle = null;
    for (var i = 0; i < toggles.length; i++) {
      if (!drawer.contains(toggles[i])) { openToggle = toggles[i]; break; }
    }
    if (openToggle) { openToggle.click(); } else { window.location.hash = '#cart-drawer'; }
  }

  var form = section.querySelector('[data-lp-purchase-form]');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var fd = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: fd
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function (data) { openCartDrawer(data); })
        .catch(function () { form.submit(); });
    });
  }
})();
